import PaymnetStore from "../../../store/paymnet-store";
import UserStore from "../../../store/user-store";
import {apiClient} from "../../../AxiosConfig";

const apiUrl = process.env.REACT_APP_API_URL;
const TG_WEB_APP = window.Telegram.WebApp


export const getLavaTopInvoice = async (planId, planConfigId, paymentMethod, langCode) => {
    const body = {
        "plan_id": planId,
        "plan_config_id":  planConfigId,
        "payment_method": paymentMethod,
        "lang_code": langCode === 'ru' ? 'ru' : 'en',
        "email": PaymnetStore.email
    }
    if (UserStore.partnerId) {
        body["partner_id"] = UserStore.partnerId
    }
    apiClient.post(`${apiUrl}/v1/invoices/lava-top-invoice`, {
        ...body
    },).then(data => {
        if (data.status === 200 && PaymnetStore.isPaymentProcessed) {
            PaymnetStore.setPaymentUrl(data.data?.payment_url)
            PaymnetStore.setTxId(data.data?.tx_id)
            PaymnetStore.setIsPaymentUrlOpened(true)
            TG_WEB_APP.openLink(data.data?.payment_url)

        }
    })
}
